import { connect } from 'react-redux';
import { ManageOrgsComponent } from './manage-orgs.component';
import { AppState } from '../../app.state';

export const ManageOrgs = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageOrgsComponent as any
) as unknown as typeof ManageOrgsComponent;
